export const adap_cange_mov = ({usuario, cange, metodo,datos}) => {

    let obj = {
        tipo: 'Puntos',
        idUsuario: usuario.id,
        codigoUsuario: usuario.codigo,
        fecha: cange.fecha,
        hashString: cange.hashString,
        hash: cange.hash,
        consecutivo: cange.consecutivo,
        nombre: usuario.nombre,
        valor: cange.valor,
        moneda: 'PUNTOS',
        departamento: 'Adminstracion',
        correo: usuario.correo,
        visible: 'Visible',
        detalle: cange.detalle,
        metodo: metodo,
        datos: datos
    }

    console.log(obj)
    return obj


}